import { FormattedMessage } from '@alltrails/shared/react-intl';
import CarouselDisplayTrigger from '@alltrails/analytics/enums/CarouselDisplayTrigger';
import UpsellModal from 'components/UpsellModal';
import * as styles from './FlyoverUpsell.module.scss';

type Props = {
  isOpen: boolean;
  onClick?: () => void;
  onRequestClose: () => void;
  flyoverHref: string;
};

// Desktop trial: https://www.figma.com/file/oniF4lWHR9LKNsYuFSlI1s/Flyovers?node-id=2804%3A199213&t=VbwNZSrqsexKiBYN-4
// Mobile trial: https://www.figma.com/file/oniF4lWHR9LKNsYuFSlI1s/Flyovers?node-id=2804%3A200250&t=VbwNZSrqsexKiBYN-4
// Desktop non-trial: https://www.figma.com/file/oniF4lWHR9LKNsYuFSlI1s/Flyovers?node-id=2772%3A200613&t=VbwNZSrqsexKiBYN-4
// Mobile non-trial: https://www.figma.com/file/oniF4lWHR9LKNsYuFSlI1s/Flyovers?node-id=1634%3A200518&t=VbwNZSrqsexKiBYN-4
export default function FlyoverUpsell({ isOpen, onClick, onRequestClose, flyoverHref }: Props) {
  return (
    <UpsellModal
      headerClassName={styles.header}
      heading={<FormattedMessage defaultMessage="Preview any trail with a 3D flyover" />}
      isOpen={isOpen}
      onClick={onClick}
      onRequestClose={onRequestClose}
      returnTo={flyoverHref}
      text={
        <FormattedMessage defaultMessage="Immerse yourself in a 3D preview to anticipate every twist and turn. Get AllTrails+ to unlock this feature and more:" />
      }
      trigger={CarouselDisplayTrigger.Flyover}
    />
  );
}
